/**
 * 创建人：yjs
 * 时间：2019-10-10
 * 描述：将文件的字节大小转化为不同单位的大小
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * 将文件的字节大小转化为不同单位的大小
 * @example <td [innerHTML]="data.isPublish | fileSize"></td>
 */
@Pipe({
  name: 'fileSize'
})

export class FileSizePipe implements PipeTransform {

  //获取当前dom节点
  constructor(private dom: DomSanitizer){}
  
  unitArr = ["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"]
    /**
     * 管道的初始化方法
     * @param value 传入的数据 number 或者 string
     */
    transform(value: string | number|any ): any {
      if(+value){
        //表面该HTML是可信赖的
        var index = 0
        var srcsize = parseFloat(value)
        index = Math.floor(Math.log(srcsize) / Math.log(1024))
        var size = srcsize / Math.pow(1024,index)
        //保留两位小数
        let newsize = size.toFixed(2)
        return newsize+this.unitArr[index]
      } else {
        return '0 Bytes'
      }
    }

}
